/* The Starter Main Structure Is 
	[
		{id, email, password , displayName , address , phone , cardPlaceholderName , cardNumber , cardDate}
	]
*/
const users = [
	{
		id: 1,
		email: "admin@admin.com",
		password: "12345678",
		displayName: "Ali Elroby",
		address: "Lorem ipsum dolor sit amet, 228123",
		phone: "01117576971",
		cardPlaceholderName: "Ali Elroby",
		cardNumber: "4456-2132-323-112",
		cardDate: "02/24"
	},
	{
		id: 2,
		email: "aliadelelroby@gmail.com",
		password: "12345678",
		displayName: "Ali Elroby",
		address: "Lorem ipsum dolor sit amet, 228123",
		phone: "01117576971",
		cardPlaceholderName: "Ali Elroby",
		cardNumber: "4456-2132-323-112",
		cardDate: "02/24"
	}
];
export default users;
